module.exports = __webpack_public_path__ + "img/wncs-icon.6781bb0.svg";